import { getGtag } from "@/lib/gtag";

export const CONSENT_KEY = "cookie-consent";

export type ConsentChoice = "granted" | "denied";

export function getStoredConsent(): ConsentChoice | null {
  try {
    const val = localStorage.getItem(CONSENT_KEY);
    if (val === "granted" || val === "denied") return val;
  } catch {
    // localStorage unavailable
  }
  return null;
}

export function applyConsent(choice: ConsentChoice) {
  const gtag = getGtag();
  if (typeof gtag === "function") {
    gtag("consent", "update", {
      ad_storage: choice,
      ad_user_data: choice,
      ad_personalization: choice,
      analytics_storage: choice,
    });
  }
}

/** Restore consent from localStorage on page load (before any React renders). */
export function restoreConsent() {
  const stored = getStoredConsent();
  if (stored) applyConsent(stored);
}
